export default "__VITE_ASSET__BaS6dR55__"